import { isNil } from "./boolean";

const ALLOWED_SPECIAL_CHARS = {
  default: "[a-zA-Z0-9.!#$%&'*/=?^_`{|}~-]",
  // We have certain accounts on PROD that use the plus symbol
  // ...prior to update to remove plus symbol validation.
  'allow-plus': "[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]"
};

export const emailRegex =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export const validateEmailFormat = (email, isOptional, validationType = 'default') => {
  const specialCharRegex = ALLOWED_SPECIAL_CHARS[validationType] || ALLOWED_SPECIAL_CHARS.default;

  if (isOptional && !email) {
    return true;
  }

  const regEx = new RegExp(
    `^${specialCharRegex}+@` +
      `[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$`
  );

  return regEx.test(email);
};

export const validateMissingEmail = (email, isOptional) => {
  if (isOptional) return true;
  if (typeof email !== 'string') return false;
  return email ?? !!email;
};

export const validateEmailLength = (email, isOptional = false) => {
  return email.length <= 40 || isOptional;
};

export const escapeRegex = (text) => {
  if (typeof text !== 'string' || text.length <= 0) {
    return '';
  }

  return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
};

export function maskEmailAddress(email) {
  const isValidEmail = validateEmailFormat(email);
  if (!isValidEmail) {
    return email;
  }

  const emailParts = email.split('@') || [];
  const username = emailParts[0] || '';
  if (username.length < 3) {
    return `•••@${emailParts[1]}`;
  } else {
    return email.replace(/^(.)(.*)(.@.*)$/, (_, a, b, c) => a + b.replace(/./g, '•') + c);
  }
}

export function checkEmailsMatch(email, emailToCheck) {
  if (!email || !emailToCheck || typeof email !== 'string' || typeof emailToCheck !== 'string') return false;
  return email.toLowerCase() === emailToCheck.toLowerCase();
}

export function validateEmailIsNotSubscriberEmail(emails, subscriberEmail) {
  let emailsAreValid;
  return new Promise((resolve, reject) => {
    if (Array.isArray(emails)) {
      if (emails?.length === 0) {
        emailsAreValid = false;
        return reject(emailsAreValid);
      }
      emailsAreValid = emails.every((email) => {
        if (isNil(email)) return false;
        return !checkEmailsMatch(email, subscriberEmail);
      });
    } else {
      emailsAreValid = !checkEmailsMatch(emails, subscriberEmail);
    }
    emailsAreValid ? resolve(emailsAreValid) : reject(emailsAreValid);
  });
}
